import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Junta classes resolvendo conflitos do Tailwind: `cn('p-4', 'p-6')` devolve
 * `p-6`. Sem isso, uma classe passada por prop não conseguiria sobrescrever a
 * do componente — as duas ficariam no atributo e o vencedor dependeria da
 * ordem no CSS gerado.
 */
export function cn(...classes: ClassValue[]): string {
  return twMerge(clsx(classes))
}
